import { CONSTANTS } from "../../constants";
import commonService from "../../utils/common.utils";
import { createBrowserHistory } from "history";

function handleResponse(res: any, navigate?: any) {
  const router: any = createBrowserHistory();
  if (!res.ok) {
    if (
      res.status === CONSTANTS.HTTP_STATUS.FORBIDDEN ||
      res.status === CONSTANTS.HTTP_STATUS.NOT_FOUND ||
      res.status === CONSTANTS.HTTP_STATUS.INTERNAL_SERVER_ERROR
    ) {
      commonService.toastService(
        res?.data ? commonService.flattenObjectToString(res?.data) : "error",
        "error"
      );
    } else if (res.status === CONSTANTS.HTTP_STATUS.UNAUTHORIZED) {
      localStorage.clear();
      commonService.toastService(
        res?.data ? commonService.flattenObjectToString(res?.data) : "error",
        "error"
      );
      setTimeout(() => {
        navigate.push("/");
      }, 2000);

      commonService.toastService(
        res?.data ? commonService.flattenObjectToString(res?.data) : "error",
        "error"
      );
      setTimeout(() => {
        navigate.push("/");
      }, 2000);
    } else if (res.status === CONSTANTS.HTTP_STATUS.BAD_REQUEST) {
      return res;
    }
  }

  return res;
}

export default handleResponse;
